import {useDebugValue, useState} from 'react';

import {resize} from '@homeaway/raf-optimized';

import {undef} from '../utils/undef';

import {useInitialization} from './useInitialization';

function useViewportSize() {
    const initialSize = {
        width: undef,
        height: undef
    };

    const [
        size,
        setSize
    ] = useState(initialSize);

    function updateSize(nextSize) {
        setSize((prevSize) => ({
            ...prevSize,
            ...nextSize
        }));
    }

    useInitialization(function initializeSize() {
        /* istanbul ignore next */
        const initializedSize = {
            width: window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth,
            height: window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight
        };

        updateSize(initializedSize);
    });

    useInitialization(function initializeResize() {
        return resize(updateSize);
    });

    const {
        width,
        height
    } = size;

    const result = {
        width,
        height
    };

    useDebugValue(result);

    return result;
}

export {useViewportSize};
